<div class="container">
  <div class="row">
    <div class="col">
      <ma-header></ma-header>
    </div>
    <div class="col-4 text-right">
      <button class="btn btn-primary" type="button" (click)="bootstrap()">
        Bootstrap
      </button>
    </div>
  </div>

  <div class="row">
    <div class="col-6">
      <ma-chart-block
        label="Total active profiles"
        [isLoading]="isActiveProfileInFlowsLoading$ | async"
        [chartData]="activeProfileInFlows$ | async"
      ></ma-chart-block>
    </div>
    <div class="col-6">
      <ma-chart-block
        label="Created flows over time"
        [isLoading]="isCreatedFlowsByDaysLoading$ | async"
        [chartData]="createdFlowsOverTime$ | async"
        [showInterval]="true"
        (intervalChange)="onIntervalChange$.next($event)"
      ></ma-chart-block>
    </div>
    <div class="col-12">
      <ma-chart-block
        label="Active flows over time"
        [isLoading]="isActiveFlowsLoading$ | async"
        [chartData]="activeFlows$ | async"
        (periodChange)="activeFlowsChange($event)"
      ></ma-chart-block>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <ma-flow-check></ma-flow-check>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <ma-account-stats
        [accounts]="accountFlowStatistics$ | async"
      ></ma-account-stats>
    </div>
  </div>
</div>
